import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { User } from '#users/types/user.type';

import { Uri } from '#constants/uri';

/**
 * Fetches the users assigned to a single role.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the role.
 * @returns OperationResultWithData wrapping `User[]`.
 */
export const getRoleUsers = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.get<OperationResultWithData<User[]>>(formatString(Uri.roles.users, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
